'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var scrollToElement = require('scroll-to-element');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var utils = require('../../utils/main');
var modal = require('../../modal');
var appDom = require('../../app-dom');

var dom;

var setupDom = function() {

	dom = {};
	dom.bookingForm = appDom.document.find('.scheduler-booking-form');
	dom.serviceForm = appDom.document.find('.scheduler-detail__form');

};

var addEventHandlers = function() {

	appDom.document.on('click', '.scheduler-calendar__month-next-arrow', onNextArrowClicked);
	appDom.document.on('click', '.scheduler-calendar__month-prev-arrow', onPrevArrowClicked);
	appDom.document.on('click', '.scheduler-calendar__date-with-availability', onDateWithAvailabilityClicked);
	appDom.document.on('change', '.scheduler-times__time', onTimeSelected);
	appDom.document.on('schedule_button_clicked', onScheduleBtnClicked);

};

var onScheduleBtnClicked = function(e, data) {

	loadCalendar({
		performScroll: true
	});

};

var onTimeSelected = function() {

	var $time = $(this);
	var $container = $time.parents('.scheduler-times');

	$.ajax({
		url: utils.getUrl('scheduler.bookingForm'),
		type: 'post',
		data: {
			appointmentDate: $container.attr('data-selected-date'),
			appointmentTime: $time.attr('data-appointment-time'),
			serviceId: $container.attr('data-service-id')
		}
	}).done(onRenderBookingFormDone);

};

var onRenderBookingFormDone = function(response) {

	appDom.document.find('.scheduler-booking-form').html(response.markup).show();

	scrollToElement({
		element: '.scheduler-booking-form',
		force: true
	});

};

var onDateWithAvailabilityClicked = function() {

	var selectedDate = $(this).attr('data-date');

	loadCalendar({
		selectedDate: selectedDate,
		calendarDate: selectedDate
	});

};

var loadCalendar = function(options) {

	var args = {
		serviceId: dom.serviceForm.attr('data-item-id'),
		selectedDate: undefined,
		calendarDate: undefined,
		direction: undefined,
		performScroll: false
	};

	$.extend(args, options)

	if (typeof selectedDate !== 'undefined') {
		args['selectedDate'] = selectedDate;
	}

	if (typeof calendarDate !== 'undefined') {
		args['calendarDate'] = calendarDate;
	}

	if (typeof direction !== 'undefined') {
		args['direction'] = direction;
	}

	$.ajax({
		url: utils.getUrl('scheduler.calendar'),
		type: 'post',
		data: args
	}).done(function(response) {

		console.log('loading calendar done, here are opts');
		console.log(args);

		onLoadCalendarDone(response, args.performScroll);


	});

};

var onLoadCalendarDone = function(response, performScroll) {

	appDom.document.find('.scheduler-date-time').html(response.markup);

	if (performScroll) {

		scrollToElement({
			element: '.scheduler-date-time',
			force: true
		});

	}

};

var onNextArrowClicked = function() {

	var $arrow = $(this);

	loadCalendar({
		selectedDate: $arrow.attr('data-selected-date'),
		calendarDate: $arrow.attr('data-calendar-date'),
		direction: 'next'
	});

};

var onPrevArrowClicked = function() {

	var $arrow = $(this);

	loadCalendar({
		selectedDate: $arrow.attr('data-selected-date'),
		calendarDate: $arrow.attr('data-calendar-date'),
		direction: 'prev'
	});

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};
